<template>
    <div class="beacons-index">
        <div class="beacons-ban">
            <banHead :bannerHead="bannerHead"></banHead>
        </div>
        <section>
            <div>
                <!--beacons-->
                <!--<div class="Beacons" id="beacons">-->
                <!--<div class="center">-->
                <!--<h2>Beacons</h2>-->
                <!--<h4>All Sensoro Beacons Fully Support for The Latest Eddystone-EID</h4>-->
                <!--<p v-for="item in beaconMes">{{item}}</p>-->
                <!--<img src="../../static/image/product/Beacons@1x.png" _src="/static/image/product/Beacons@2x.png" alt="">-->
                <!--</div>-->
                <!--</div>-->
                <!--产品功能-->
                <div class="product-Fun">
                    <div class="center">
                        <productList :proFunction="proFunction"></productList>
                    </div>
                </div>
                <!--产品列表-->
                <div class="product-List">
                    <div class="center">
                        <productList :proFunction="proList"></productList>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import banHead from '../common/banHead';
    import productList from '../common/productList';
    import proFunction from '../assets/js/productList'

    export default {
        name: "beacons",
        data() {
            return {
                bannerHead: {
                    title: 'All Sensoro Beacons Fully Support for The Latest Eddystone-EID',
                    msg: 'Eddystone-EID allows customers to manage access to beacons for use-cases where privacy and security is a concern.',
                    // _src:'/static/image/case/CaseStudies-banner@2x.jpg',
                    imgSrc: '/static/image/product/beacons_banner@1x.png',
                    imgSrc1: '/static/image/product/beacons_banner@2x.png'
                },
                //beacons介绍
                beaconMes: [
                    'ddystone-EID allows customers to manage access to beacons for use-cases where privacy and security is a concern.',
                    'Order Sensoro beacons with firmware 4.3 which fully support for Eddystone-EID from NOW.',
                    'More info about firmware 4.3.'
                ],
                proList: proFunction.proList,
                proFunction: proFunction.proFunction,
            }
        },
        mounted() {
            this.utils.getImg()
        },
        components: {
            banHead,
            productList
        }
    }
</script>

<style lang="less">
    @baseWidth: 1640px;
    @baseColor: #5D5D5D;
    @baseFontColor: #252525;
    .beacons-index {
        width: 100%;
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .center {
            width: @baseWidth;
            margin: 0 auto;
            height: 100%;
        }
        h1 {
            font-size: 40px;
            line-height: 64px;
        }
        p {
            font-size: 16px;
            line-height: 26px;
        }
        .beacons-ban {
            width: 100%;
            .com-banner {
                background: #383838;
                h1{
                    font-size: 28px;
                    line-height: 40px;
                    margin-bottom: 24px;
                }
                .center {
                    display: flex;
                    align-items: center;
                    justify-items: center;
                    justify-content: space-between;
                    .banner-pro {
                        width: 40%;
                        padding-right: 100px;
                    }
                    img{
                        /*width: 50%;*/
                        height: 100%;
                    }
                }
            }
        }
    }

    section {
        width: 100%;
        .Beacons {
            width: 100%;
            color: #252525;
            text-align: center;
            padding: 96px 0 100px;
            h2 {
                font-size: 28px;
                line-height: 48px;
            }
            h4 {
                font-size: 18px;
                line-height: 26px;
                margin: 20px 0 16px;
            }
            p {
                width: 750px;
                margin: 0 auto;
                font-size: 14px;
                color: #5D5D5D;
                line-height: 22px;
            }
            img {
                margin-top: 64px;
                width: 280px;
            }
        }
        .product-List, .product-Fun {
            .product-list {
                display: flex;
            }
        }
        .product-Fun {
            /*border-bottom: 1px solid #DFDFDF;*/
            padding-top: 96px;
            background: #fafafa;
        }
        .product-List {
            /*margin-top: 96px;*/
            padding-top: 96px;
            .product-list {
                .product-info {
                    margin-bottom: 96px;
                    img {
                        width: 380px;
                        height: 380px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1680px) {
        @baseWidth: 1216px;
        @autoWidth: 1256px;
        .beacons-index {
            width: 100%;
            min-width: @autoWidth;
            .center {
                width: @baseWidth;
                margin: 0 auto;
            }
            .beacons-ban {
                .com-banner {
                    h1{
                        font-size: 28px;
                        line-height: 40px;
                        margin-bottom: 24px;
                    }
                    .center {
                        display: flex;
                        align-items: center;
                        justify-items: center;
                        padding-left: 0;
                        width: @baseWidth;
                        margin: 0 auto;
                        .banner-pro {
                            width: 40%;
                            padding-right: 0;

                        }
                        img{
                            /*width: 600px;*/
                        }
                    }
                }
            }
            section {
                /*margin-top: 96px;*/
                .product-List {
                    .product-list {
                        width: 1005px;
                        margin: 0 auto;
                        /*padding:0 100px;*/
                        .product-info {
                            display: block;
                            width: 380px;
                            h1 {
                                text-align: center;
                            }
                            .product-mes {
                                a {
                                    text-align: center;
                                }
                            }
                            img {
                                width: 260px;
                                height: 260px;
                                /*margin: 0 auto;*/
                                margin-left: 60px;
                            }
                        }
                    }
                }
                .product-List, .product-Fun {
                    .product-list {
                        justify-content: space-around;
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Beacons.vue